export default __webpack_public_path__ + "static/media/1644.56cee08e.png";